// extracted by mini-css-extract-plugin
export default {"container":"_j-z","blurb":"ak-z","links":"bk-z"};